module.exports = __webpack_public_path__ + "img/svg/arrow-down.38709761a14e2e961e23797aae9c98b2.svg";